'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { motion, useReducedMotion } from 'motion/react';
import { Shield, LogIn, Flame } from 'lucide-react';

export default function SuperAdminAuthPage() {
  const router = useRouter();
  const reduce = useReducedMotion();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !password) return;
    setBusy(true);
    setError(null);
    try {
      const res = await fetch('/api/super-admin/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (data.success) {
        router.push('/super-admin');
      } else {
        setError(data.error || 'Credenciais invalidas.');
      }
    } catch {
      setError('Não foi possível ligar ao serviço de autenticação. Tenta novamente.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-split">
        <aside
          className="auth-brand-panel auth-brand-panel--solid"
          style={{ background: 'linear-gradient(145deg, #181820 0%, #2a2a35 100%)' }}
        >
          <div className="auth-brand-content relative z-10">
            <div className="auth-brand-mark bg-white/10">
              <Shield className="w-7 h-7 text-white" />
            </div>
            <h1 className="auth-brand-title">Plataforma Okai</h1>
            <p className="auth-brand-tagline">
              Gestao central de tenants, dominios, utilizadores e numeros de voz.
            </p>
          </div>
          <div className="auth-brand-content relative z-10 flex items-center gap-3 text-sm text-white/60">
            <Flame className="w-5 h-5 flex-shrink-0" />
            <span>Acesso restrito ao dominio apex.</span>
          </div>
        </aside>

        <div className="auth-form-panel">
          <motion.div
            initial={reduce ? false : { opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            className="auth-card"
          >
            <div className="mb-6">
              <h2 className="text-2xl font-bold font-display text-ink-900">Super Admin</h2>
              <p className="text-ink-600 mt-1 text-sm">Inicia sessao para gerir a plataforma.</p>
            </div>

            {error && (
              <div className="mb-4 bg-danger-soft border border-danger/20 text-danger rounded-xl p-3 text-sm" role="alert">
                {error}
              </div>
            )}

            <form onSubmit={submit} className="space-y-4">
              <div>
                <label className="input-label" htmlFor="sa-email">Email</label>
                <input
                  id="sa-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="superadmin@okai.pt"
                  className="input-field"
                  required
                  autoComplete="email"
                />
              </div>
              <div>
                <label className="input-label" htmlFor="sa-password">Password</label>
                <input
                  id="sa-password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                  className="input-field"
                  required
                  autoComplete="current-password"
                />
              </div>
              <button
                type="submit"
                disabled={busy}
                className="btn btn-primary w-full flex items-center justify-center gap-2"
              >
                <LogIn className="w-4 h-4" />
                {busy ? 'A entrar...' : 'Entrar'}
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
